import { authenticatedPatientSelector } from '../../../main/selectors/patients-selectors.ts';

module.exports = {
  templateUrl: 'signin/components/activation/activation.html',
  controller: class Activation {

    static $inject = [
      '$ngRedux',
      '$state',
      '$scope',
      'PatientsService',
      '$stateParams',
      '$translate',
      'RegistrationService',
      'SessionService',
      'SecurityService',
    ];

    constructor($ngRedux, $state, $scope, PatientsService, $stateParams, $translate, RegistrationService, SessionService, SecurityService) {
      this.$ngRedux = $ngRedux;
      this.$state = $state;
      this.$scope = $scope;
      this.PatientsService = PatientsService;
      this.$stateParams = $stateParams;
      this.$translate = $translate;
      this.RegistrationService = RegistrationService;
      this.SessionService = SessionService;
      this.SecurityService = SecurityService;
    }

    $onInit() {
      this.initializeStateConnection();

      this.errorShouldShow = false;
      this.password = '';
      this.passwordConfirmation = '';

      this.$scope.$on('auth:validation-error', () => this.tokenError());
      this.$scope.$on('auth:invalid', () => this.tokenError());

      this.email = this.authenticatedPatient.email;
      this.loaded = true;
    }

    initializeStateConnection() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        authenticatedPatient: authenticatedPatientSelector(state),
        group: state.group,
      }))(this));
    }

    tokenError() {
      return this.$state.go('login', {
        error: 'token',
      });
    }

    performActivation(isValid) {
      if (isValid) {
        this.dataLoading = true;

        this.PatientsService.replaceAgreement(this.authenticatedPatient.id, this.group.id, () => {
          this.SessionService.updatePassword(this.password)
          .then(() => {
            this.PatientsService.loadPatient(this.authenticatedPatient.id).then((authenticatedPatient) => {
              let patientId = authenticatedPatient.id;

              // When patient self-register with it's children (PATIENT_REGISTER_DELEGATION_FORM product),
              // but only the children is member of the clinic and the clinic does not accept new patients, the parent
              // is prevented from booking. We automatically redirect to its child in that case.
              if (authenticatedPatient.subscription.preventBooking && authenticatedPatient.children.length > 0) {
                patientId = authenticatedPatient.children[0].id;
              }

              this.$state.go('patients.id.home', { patientId, token: null }, { reload: true });
            });
          });
        })
        .catch(() => {
          this.errorShouldShow = true;
          return true;
        });
      }

      this.errorShouldShow = true;
      return true;
    }

    hasErrors(ngModel) {
      return this.RegistrationService.hasErrors(ngModel);
    }

    canSubmit() {
      return this.RegistrationService.canSubmit(this.form);
    }
  },
};



// WEBPACK FOOTER //
// ./signin/components/activation/activation.js